
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="isLoading" rounded="sm">
      <div class="card">
        <div class="form-row">
          <div class="form-group col-md-3">
            <label>Periodo</label>
            <month-picker-input
                @change="cambiarMes"
                style="z-index:1"
                :default-month="mes_actual"
            ></month-picker-input>
            <!--<select class="form-control" v-model="periodo" >

              <option value="2023-12-01|2023-12-31">Diciembre - 2023</option>
              <option value="2024-01-01|2024-01-31">Enero - 2024</option>
              <option value="2024-02-01|2024-02-29">Febrero - 2024</option>
              <option value="2024-03-01|2024-03-31">Marzo - 2024</option>
              <option value="2024-04-01|2024-04-30">Abril - 2024</option>
              <option value="2024-05-01|2024-05-31">Mayo - 2024</option>
              <option value="2024-06-01|2024-06-30">Junio - 2024</option>
              <option value="2024-07-01|2024-07-31">Julio - 2024</option>
              <option value="2024-08-01|2024-08-31">Agosto - 2024</option>
              <option value="2024-09-01|2024-09-30">Septiembre - 2024</option>
            </select>-->
          </div>
          <div class="form-group col-md-3">
            <label>Tipo costo</label>
            <select class="form-control" v-model="tipo_costo" >
              <option value="0">(Todos)</option>
              <option value="Costo directo">Costo directo</option>
              <option value="Costo indirecto">Costo indirecto</option>
            </select>
          </div>
          <!--<div class="form-group col-md-3">
            <label>Mayores metrados</label>
            <select class="form-control" v-model="mayores_metrados" >
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label>Nuevas partidas</label>
            <select class="form-control" v-model="nuevas_partidas" >
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>
          </div>-->
        </div>
        <div class="row">
          <table class="table table-bordered table-responsive">
            <thead>
            <tr class="borde-abajo">
              <th colspan="2" class="text-center " style="background-color: var(--expediente);">
                <strong>EXPEDIENTE TÉCNICO</strong>
              </th>
              <th colspan="2"  class="text-center borde-izquierda" style="background-color: var(--cronograma);">AVANCE PROGRAMADO </th>
              <th colspan="2"  class="text-center borde-izquierda" style="background-color: var(--avancefisico);" >AVANCE FÍSICO</th>
              <th colspan="2" class="text-center borde-izquierda" style="background-color: var(--avancefinanciero);">AVANCE FINANCIERO</th>
            </tr>
            <tr class="borde-abajo">
              <th style="background-color: var(--expediente);">Expediente</th>
              <th style="background-color: var(--expediente);" class="borde-izquierda">Presupuesto</th>

              <th  style=" background-color: var(--cronograma);" class="borde-izquierda" >Programado acumulado</th>
              <th  style=" background-color: var(--cronograma);">Programado actual</th>

              <th style=" background-color: var(--avancefisico);" class="borde-izquierda" >Avance acumulado</th>
              <th style=" background-color: var(--avancefisico);">Avance actual </th>

              <th style=" background-color:var(--avancefinanciero);" class="borde-izquierda" >Avance acumulado</th>
              <th style=" background-color: var(--avancefinanciero);">Avance actual</th>

            </tr>
            </thead>
            <tbody v-for="(row, index) in expedientes" :key="index" >

              <tr >
                <td rowspan="2"><strong>{{row.descripcion}}</strong></td>
                <td rowspan="2" class="text-right borde-izquierda">
                  {{row.totales.total}}
                </td>
                <!--////PROGRAMADO-->
                <td  class="text-right borde-izquierda"  >
                  {{row.totales.cronograma_acumulado }}
                </td>
                <td  class="text-right ">
                  {{row.totales.cronograma_actual }}
                </td>
                <!--////AVANCE FISICO-->
                <td class="text-right  borde-izquierda">
                  {{row.totales.valorizacion_acumulada  }}
                </td>
                <td class="text-right">
                  {{row.totales.valorizacion_actual  }}
                </td>

                <td class="text-right  borde-izquierda">
                  {{row.totales.avance_financiero_ca  }}
                </td>
                <td class="text-right">
                  {{row.totales.avance_financiero_ca_actual}}
                </td>
              </tr>
            <tr class="borde-abajo">
              <td class="text-right  borde-izquierda">{{row.totales.cronograma_acumulado_porcentaje+"%"}}</td>
              <td class="text-right">{{row.totales.cronograma_actual_porcentaje+"%"}}</td>

              <td class="text-right  borde-izquierda">{{row.totales.valorizacion_acumulada_porcentaje+"%"}}</td>
              <td class="text-right">{{row.totales.valorizacion_actual_porcentaje+"%"}}</td>

              <td class="text-right  borde-izquierda">{{row.totales.avance_financiero_ca_porcentaje+"%"}}</td>
              <td class="text-right ">{{+row.totales.avance_financiero_ca_actual_porcentaje+"%"}}</td>
            </tr>



            </tbody>
          </table>

        </div>

      </div>

    </b-overlay>


  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,

  },
  methods:{
    cargarReporte(){
      this.isLoading=true;
      this.expedientes=[];
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes/reporte",
          {
            params:{
              fecha_mes:this.fecha_mes,
              periodo:this.periodo,
              tipo_costo:this.tipo_costo,
              mayor_metrado:this.mayores_metrados,
              nuevas_partidas:this.nuevas_partidas
            }
          })
          .then((response)=>{
            this.expedientes=response.data;
          })
          .finally(()=>this.isLoading=false)
    },
    cambiarMes(date){
      var fec = new Date(date.year, date.monthIndex-1, 1);
      var fec_str=fec.toISOString().substring(0,10);
      this.fecha_mes=fec_str;
      this.cargarReporte();
    }
  },
  mounted() {
    this.cargarReporte();
    //this.periodo="";
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      expedientes:[],
      isLoading:false,
      tipo_costo:"0",
      fecha_mes:{

      },
      mes_actual:this.$mesActual(),
    };
  },
  watch:{
    periodo:function(){
      this.cargarReporte();
    },
    tipo_costo:function(){
      this.cargarReporte();
    },
    mayores_metrados:function(){
      this.cargarReporte();
    },
    nuevas_partidas:function(){
      this.cargarReporte();
    },

  }

};
</script>
<style>
:root {
  --cronograma:#FFFBD1E3;
  --avancefisico: #c4def8;
  --avancefinanciero: #bffabf;
  --expediente: #e5e5e5;
}
.bordetabla {
  border: 2px solid rgba(193, 193, 193, 0.89) !important;
}
.borde-abajo {
  border-bottom: 2px solid rgba(193, 193, 193, 0.89) !important;
}
.borde-izquierda {
  border-left: 2px solid rgba(220, 220, 220, 0.89) !important;
}
</style>
